import { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import SettingsIcon from "@mui/icons-material/Settings";
import CommentIcon from "@mui/icons-material/Comment";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";
import DescriptionIcon from '@mui/icons-material/Description';
import { useSelector } from "react-redux";
import { COMMON_COMPONENT_TYPES, NODE_TYPES } from "constants/flowDesigner";
import SoftBox from "components/SoftBox";
import { ThemedHelpIcon } from "assets/CXFIcons/Portal/Navigation";
import { IconButton } from "@mui/material";
import { DocumentationDialog } from "../Documentation";

const NodePanelTabs = ({ tabValue, onChange, isConnector }) => {
  const { t } = useTranslation("flowDesigner");
  const { selectedNode } = useSelector((store) => store?.designer?.componentPropsPanel);
  const [isDocumentationOpen, setIsDocumentationOpen] = useState(false);

  const handleDocumentation = () => {
    const isConnectorNode = selectedNode.type !== NODE_TYPES.COMMON;

    if (isConnectorNode) {
      setIsDocumentationOpen(true);
      return;
    }

    try {
      const url = new URL(selectedNode?.documentation);
      window.open(url.href, "_blank");
    } catch {
      // invalid URL — do not open
    }
  };

  return (
    <SoftBox
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        pr: 1,
        mb: 1
      }}
    >
      <Tabs
        value={tabValue}
        variant="scrollable"
        orientation="horizontal"
        scrollButtons="auto"
        onChange={onChange}
        allowScrollButtonsMobile
        sx={{
          minHeight: "40px",
          "& .MuiTabs-scrollButtons": {
            zIndex: 5,
            width: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "4px"
          },
        }}
      >
        {selectedNode?.key !== COMMON_COMPONENT_TYPES.END && (
          <Tab 
            icon={<SettingsIcon />} 
            iconPosition="start" 
            label={t("common.node_properties")} 
          />
        )}

        <Tab 
          icon={<DescriptionIcon />} 
          iconPosition="start" 
          label={t("common.description")} 
        />


        <Tab 
          icon={<CommentIcon />} 
          iconPosition="start" 
          label={t("common.comments")} 
        />
        
        {isConnector && (
          <Tab 
            icon={<LibraryAddCheckIcon />} 
            iconPosition="start" 
            label={t("common.versions")} 
          />
        )}
      </Tabs>

      <IconButton
        onClick={handleDocumentation}
        sx={{
          ml: 2,
          mb: 1.3,
          flexShrink: 0
        }}
      >
        <ThemedHelpIcon />
      </IconButton>
      <DocumentationDialog
        selectedNode={selectedNode}
        isOpen={isDocumentationOpen}
        closeDialog={() => setIsDocumentationOpen(false)}
      />
    </SoftBox>
  );
};

export default memo(NodePanelTabs);

